import { Choice, CurdDataSetConfig, FormFieldType } from '../types';
import { choiceTypeOptions } from './choice-type-list';

const filetConfig = [
  {
    key: 'value',
    label: 'Valor',
    type: FormFieldType.STRING,
  },
  {
    key: 'fieldKey',
    label: 'Tipo de campo',
    type: FormFieldType.OPTIONS_MULTIPLE,
    options: choiceTypeOptions
  },
  {
    key: 'labelDefault',
    label: 'Etiqueta por defecto',
    type: FormFieldType.STRING,
  },

  {
    key: 'labelEs',
    label: 'Etiqueta en español',
    type: FormFieldType.STRING
  },

  {
    key: 'labelEn',
    label: 'Etiqueta en ingles',
    type: FormFieldType.STRING,
  },
];

export const choicesDataSetConfig: CurdDataSetConfig<Choice> = {
  entityName: 'Opcion',
  collectionName: 'Choices',
  gatewayUrl: 'choices',
  baseBreadcrumb: 'choices',
  form: {
    listRedirectUrl: 'console/system/choices/list',
    fields: [
      {
        key: 'value',
        label: 'Valor',
        type: FormFieldType.STRING,
        containerClass: 'col-md-6 col-sm-12'
      },
      {
        key: 'fieldKey',
        label: 'Tipo de campo',
        type: FormFieldType.OPTIONS,
        containerClass: 'col-md-6 col-sm-12',
        options: choiceTypeOptions
      },
      {
        key: 'labelDefault',
        label: 'Etiqueta por defecto',
        type: FormFieldType.STRING,
        containerClass: 'col-md-4 col-sm-4',
        fillValue: (c) => (c?.label || {})['default'] || ''
      },
      {
        key: 'labelEs',
        label: 'Etiqueta en español',
        type: FormFieldType.STRING,
        containerClass: 'col-md-4 col-sm-4',
        fillValue: (c) => (c.label || {})['es'] || ''
      },
      {
        key: 'labelEn',
        label: 'Etiqueta en ingles',
        type: FormFieldType.STRING,
        containerClass: 'col-4 col-sm-4',
        fillValue: (c) => (c?.label || {})['en'] || ''
      },
      {
        key: 'image',
        image: (value) => value,
        label: 'Imagen URL',
        type: FormFieldType.STRING,
        containerClass: 'col-4 col-sm-4',
      },
      {
        key: 'icon',
        label: 'Clase del Icono',
        type: FormFieldType.STRING,
        containerClass: 'col-4 col-sm-4',
      },
      {
        key: 'color',
        label: 'Color',
        type: FormFieldType.STRING,
        containerClass: 'col-4 col-sm-4',
      },
      {
        key: 'description',
        label: 'Descripcion',
        type: FormFieldType.STRING,
        containerClass: 'col-12 col-sm-12',
        optionsGateway: 'sim-cards'
      }
    ],
    handleObject: data => {
      const label = {
        default: data['labelDefault'],
        es: data['labelEs'],
        en: data['labelEn']
      };

      return {
        ...data,
        label
      }
    }
  },
  list: {
    pageConfig: {
      title: 'Lista de opciones del sistema',
      breadcrumb: [
        {
          title: 'Sistema',
          type: 'item',
          link: '/console/system/choices/list'
        },
        {
          title: 'Opciones',
          type: 'item',
          link: '/console/system/choices/list'
        },
        {
          title: 'Lista',
          type: 'item',
          link: '/console/system/choices/list',
          pageName: 'Opciones del sistema'
        }
      ]
    },
    filter: filetConfig,
    searchFilter: filetConfig,
    table: {
      columns: [
        {
          key: 'label', label: 'Etiqueta',
          getValue:  ({ element }) => element.label['es'] || element.label['default'] || 'No definido'
        },
        { key: 'value', label: 'Valor' },
        { key: 'description', label: 'Descripcion', },
        {  key: 'fieldKey', label: 'Tipo'}
      ]
    },
    actionsKeys: ['create', 'edit', 'delete']
  },
  pages: ['list', 'create', 'edit']
};
